import { css } from "@emotion/react";

import { DesignToken } from "@livechat/design-system-react-components";

import { ResponsiveBreakpoint, ResponsiveBreakpointType } from "constants/responsive-breakpoint";

export const disableLabelStyles = css`
  display: flex;
  align-items: center;
  margin-right: 100%;
  color: var(${DesignToken.ActionNegativeDefault});
  height: 100%;
  &:hover {
    color: var(${DesignToken.ActionNegativeActive});
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const webpushParagraphStyles = css`
  margin: 20px 0px;
  font-size: 14px;
`;

export const enableNotificationButtonStyles = css`
  padding: 6px 16px;
`;

export const headerStyles = css`
  margin-bottom: 11px;
`;

export const mobileButtonStyles = css`
  color: var(${DesignToken.ColorWhite});
  text-decoration: underline;
  &:hover {
    color: var(${DesignToken.ContentInvertSecondary});
  }
`;

export const mobileBarStyles = css`
  @media (max-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile]}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const buttonContainerStyles = css`
  @media (max-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile]}px) {
    margin: 16px 28px 0;
  }
`;
